<div class="relative w-full h-full" [style.minHeight.px]="minHeightPx">
  @if (chartOptions && Object.keys(chartOptions).length > 0) {
    <div 
      echarts 
      [options]="chartOptions"
      [loading]="loading"
      [autoResize]="true"
      (chartInit)="onChartInit($event)"
      class="w-full h-full transition-opacity duration-300"
      [class.opacity-30]="loading"
      [class.opacity-100]="!loading">
    </div>
  } @else {
    <div
      class="flex flex-col items-center justify-center h-full bg-linear-to-b from-[#0f3552]/20 via-[#0a2740]/20 to-[#071e33]/20 border border-white/10 rounded-lg"
      [style.minHeight.px]="minHeightPx"
    >
      <span class="material-symbols-outlined text-[48px] text-slate-400/50 mb-4">
        insert_chart
      </span>
      <span class="text-[16px] font-medium text-slate-300 mb-2">
        No Data Available
      </span>
    </div>
  }
</div>
